import { useTranslation } from 'next-i18next';
interface LoadingSpinnerProps {
  message?: string;
}

/**
 * 전체 화면 로딩 스피너 컴포넌트
 *
 * 페이지 로딩이나 비동기 작업 대기 시 표시되는 공통 로딩 UI입니다.
 */
export function LoadingSpinner({
  message
}: LoadingSpinnerProps) {
  const {
    t
  } = useTranslation(['common']);
  const displayMessage = message ?? t('common:global.loading');
  return <div className="flex min-h-screen items-center justify-center bg-gray-50" data-sentry-component="LoadingSpinner" data-sentry-source-file="LoadingSpinner.tsx">
      <div className="flex flex-col items-center gap-4">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-violet-500 border-t-transparent" />
        <p className="text-body-md-medium text-gray-600">{displayMessage}</p>
      </div>
    </div>;
}